module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.goOff()
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "arrow-left",
      "size": "1.5em"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600",
      "color": "#000"
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "touyide"
  }, [_c('div', [_c('img', {
    staticClass: "touxiang",
    attrs: {
      "src": _vm.header,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "margin-left": "18px"
    }
  }, [_vm._v(_vm._s(_vm.nick))])])]), _vm._v(" "), _c('div', {
    staticClass: "xuexijilu"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "56px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "24px"
    }
  }, [_vm._v("累计学习" + _vm._s(_vm.times))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "12px"
    },
    on: {
      "click": function($event) {
        return _vm.xuexijilu()
      }
    }
  }, [_vm._v("听课记录")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "82px",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "24px"
    }
  }, [_vm._v(_vm._s(_vm.nums))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "12px"
    },
    on: {
      "click": function($event) {
        return _vm.yigoujilu()
      }
    }
  }, [_vm._v("我的已购")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53059a2c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/menu/PersonalCenter/MyPage.vue
// module id = 566
// module chunks = 0